import StopWout from '../WordPr/StopWout';
import PythonSc from '../WordPr/PythonSc';
import ProcLibraryAns from '../WordPr/ProcLibraryAns';
import stringSimilarity from 'string-similarity-js';
import ZukiAiSc from '../WordPr/ZukiAiSc';
import { useLocation } from "react-router-dom";
import CommonWords from '../WordPr/CommonWords';
import ExamsResult from './ExamsResult';

function countWords(str) {
  const wordsArray = str.split(/\b\w+\b/);
  const filteredWordsArray = wordsArray.filter(word => word !== '');
  return filteredWordsArray.length;
}



const ExamsAnswerLoader = () => {
  const { state } = useLocation();
  const submittedAnswers = state.submittedAnswers;
  const selectedQuestions = state.selectedQuestions;
  console.log(submittedAnswers, selectedQuestions);
  
  let totalScore = 0;
  let scores = [];
  let comp=selectedQuestions.length;
  let counter = 0;
  

  submittedAnswers.forEach((submittedAnswer, index) => {
    const correctAnswer = selectedQuestions[index];
    
    let usertext = null;
    let correcttext = null;
    let usercode = null;
    let correctcode = null;
    let picScore = 0;
    let textScore = 0;
    let codeScore = 0;
    let p = 0;
    let c = 0;
    let s = 0;
    let check = false
       usertext = submittedAnswer.answerText;
      correcttext = correctAnswer.apanthsh;
    if (correctAnswer.apanthsh && submittedAnswer.answerText) {
    
      
      

      if (usertext !== null && usertext !== "") {
        if ((countWords(usertext) + countWords(correcttext)) / 2 <= 20) {
          check=CommonWords({ st1: correcttext, st2: usertext });
      if (check===true) {
          
          const Pyth = PythonSc({ st1: correcttext, st2: usertext });
          const Lisc = ProcLibraryAns({ st1: correcttext, st2: usertext });
          const strng = stringSimilarity(correcttext, usertext);
          p = 1;
          textScore = (Pyth + Lisc + strng) / 3;}

        else { textScore = 0; p=1;}
        } else {
          const filteredAnswer = StopWout({ inputString: correcttext });
          const filteredUserAnswer = StopWout({ inputString: usertext });
          check=CommonWords({ st1: filteredAnswer, st2: filteredUserAnswer });
          if (check===true) {
          const Pyth = PythonSc({ st1: filteredAnswer, st2: filteredUserAnswer });
          const Lisc = ProcLibraryAns({ st1: filteredAnswer, st2: filteredUserAnswer });
          const strng = stringSimilarity(filteredAnswer, filteredUserAnswer);
          textScore = (Pyth + Lisc + strng) / 3;
          p = 1;}
          else { textScore = 0; p=1;}
        } 
      }
    }
    usercode = submittedAnswer.codeAnswer;
    correctcode = correctAnswer.code_content;
      if (submittedAnswer.codeAnswer!==null && submittedAnswer.codeAnswer!=="") {
        
        codeScore = ZukiAiSc({ st1: correctcode, st2: usercode });
        c = 1;
      }

      let questionTotalScore = 0;      
      if(p===0 && c===0 && s===0)  {
        questionTotalScore = 0;
      }
      else {
      questionTotalScore=(textScore+codeScore+picScore)/(p+c+s);
      }
       
      totalScore += questionTotalScore * parseInt(correctAnswer.Vathmos)/10;
      counter++;
      scores.push({
        index: index,
        table: selectedQuestions[index].table,
        erid: selectedQuestions[index].erid,
        question: correctAnswer.erwthsh,
        correctAnswer: correcttext,
        userAnswer: usertext,
        correctCode: correctcode,
        userCode: usercode,
        score: questionTotalScore * parseInt(correctAnswer.Vathmos),
        qsc:questionTotalScore

        
      });

  
     
     
    
  });

  
    
 
  
  console.log(scores,totalScore);

  return (
    <>
     
   {counter===comp && !isNaN(totalScore)  && totalScore!==null?(<ExamsResult totalScore={totalScore} scores={scores} />) : (<ExamsResult totalScore={NaN} scores={null} />)}

    </>
  )
};

export default ExamsAnswerLoader;
